import clsx from 'clsx'
import { FC } from 'react'
import { KTCard, WithChildren } from '../../../_metronic/helpers'
import styles from './styles/DataTable.module.css'

/**
 * KTCard com a superfície branca do padrão novo de tabela. Envolva o header de filtros +
 * <CustomTable> para que os dois fiquem no mesmo card.
 */
export const TableCard: FC<WithChildren & { className?: string }> = ({ children, className }) => (
  <KTCard className={clsx(styles.card, className)}>{children}</KTCard>
)
